import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-admin-panel-menu',
  templateUrl: './admin-panel-menu.component.html',
  styleUrls: ['./admin-panel-menu.component.scss'],
  host: {
    class: 'px-3 py-4 position-relative bg-grey-light-l d-block',
  },
  standalone: false,
})
export class AdminPanelMenuComponent implements OnInit {
  private router = inject(Router);
  private translate = inject(TranslateService);

  adminMenuItems: AdminMenuItem[];

  ngOnInit(): void {
    this.getAdminMenuItems();
  }

  public async getAdminMenuItems() {
    this.adminMenuItems = [
      {
        id: '1',
        text: await this.translate.get('ADMIN_PANEL').toPromise(),
        routePath: '/admin/dashboard',
        icon: 'mdi mdi-view-dashboard',
      },
      {
        id: '2',
        text: await this.translate.get('ADMIN_PANEL_CATALOG').toPromise(),
        icon: 'mdi mdi-format-list-bulleted-square',
        expanded: true,
        items: [
          {
            id: '2_1',
            text: await this.translate.get('ADMIN_PANEL_SERVICES').toPromise(),
            routePath: '/admin/service-catalog',
          },
          {
            id: '2_2',
            text: await this.translate.get('ADMIN_PANEL_SERVICES_CATEGORIES').toPromise(),
            routePath: '/admin/service-catalog/categories',
          },
          {
            id: '2_3',
            text: await this.translate.get('ADMIN_PANEL_SERVICES_MASTER_CATEGORIES').toPromise(),
            routePath: '/admin/service-catalog/master-categories',
          },
          {
            id: '2_4',
            text: await this.translate.get('ADMIN_PANEL_SELF_DIAGNOSIS').toPromise(),
            routePath: '/admin/service-catalog/self-diagnosis',
          },
        ],
      },
      {
        id: '3',
        text: await this.translate.get('ADMIN_PANEL_USERS').toPromise(),
        icon: 'mdi mdi-account-multiple',
      },
      {
        id: '4',
        text: await this.translate.get('ADMIN_PANEL_NOTIFICATION_TEMPLATES').toPromise(),
        routePath: '/admin/notification-templates',
        icon: 'mdi mdi-email-outline',
      },
      {
        id: '5',
        text: await this.translate.get('ADMIN_PANEL_ANALYTICS').toPromise(),
        icon: 'mdi mdi-chart-areaspline',
      },
      {
        id: '6',
        text: await this.translate.get('ADMIN_PANEL_MESSAGES').toPromise(),
        routePath: '/admin/problems',
        icon: 'mdi mdi-bell-ring-outline',
      },
    ];
  }

  public selectAdminMenuItem(event) {
    if (event.itemData.routePath != undefined) {
      this.router.navigate([event.itemData.routePath]);
    }
  }
}

export class AdminMenuItem {
  id: string;
  text: string;
  routePath?: string;
  icon?: string;
  expanded?: boolean;
  items?: AdminMenuItem[];
}
